// ---------------------------------------------------------------------------
// Data Quality Issue form model + email builder.
//
// Fields mirror the "Data Quality" sheet from the Data Engineering Request
// Forms workbook. On submit, opens an Outlook compose window with the form
// summary emailed to enterprisedata@loandepot.com.
// ---------------------------------------------------------------------------

import {
  formatDate,
  OUTLOOK_COMPOSE_BASE,
  REQUEST_RECIPIENT,
} from './intake'

export interface DataQualityValues {
  catalog: string
  schema: string
  table: string
  issueDescription: string
  transformationLogic: string
  expectedResult: string
  actualResult: string
  dateFirstObserved: string
  affectedReports: string
  businessImpact: string
  sampleRecords: string
}

export const DATA_QUALITY_INITIAL: DataQualityValues = {
  catalog: '',
  schema: '',
  table: '',
  issueDescription: '',
  transformationLogic: '',
  expectedResult: '',
  actualResult: '',
  dateFirstObserved: formatDate(new Date()),
  affectedReports: '',
  businessImpact: '',
  sampleRecords: '',
}

const SUMMARY_SECTIONS: {
  title: string
  fields: [keyof DataQualityValues, string][]
}[] = [
  {
    title: 'DATA QUALITY ISSUE',
    fields: [
      ['catalog', 'Catalog'],
      ['schema', 'Schema'],
      ['table', 'Table'],
      ['issueDescription', 'Issue Description'],
      ['transformationLogic', 'Transformation Logic'],
      ['expectedResult', 'Expected Result'],
      ['actualResult', 'Actual Result'],
      ['dateFirstObserved', 'Date Issue First Observed'],
      ['affectedReports', 'Affected Reports'],
      ['businessImpact', 'Business Impact'],
      ['sampleRecords', 'Sample Records'],
    ],
  },
]

export const DATA_QUALITY_SUBJECT =
  'Prism Portal Request - Data Quality Issue'

export function buildDataQualityEmailBody(values: DataQualityValues): string {
  const blocks: string[] = []
  for (const section of SUMMARY_SECTIONS) {
    const filled = section.fields.filter(
      ([key]) => String(values[key] ?? '').trim().length > 0
    )
    if (filled.length === 0) continue
    const lines = [section.title]
    for (const [key, label] of filled) {
      lines.push(`  ${label}: ${String(values[key]).trim()}`)
    }
    blocks.push(lines.join('\r\n'))
  }
  return blocks.join('\r\n\r\n')
}

export function buildDataQualityOutlookUrl(
  values: DataQualityValues,
  loginHint?: string | null
): string {
  const params = new URLSearchParams({
    to: REQUEST_RECIPIENT,
    subject: DATA_QUALITY_SUBJECT,
    body: buildDataQualityEmailBody(values),
  })
  if (loginHint && loginHint.trim()) {
    params.set('login_hint', loginHint.trim())
  }
  const query = params.toString().replace(/\+/g, '%20')
  return `${OUTLOOK_COMPOSE_BASE}?${query}`
}
